function addScrolledClassToBody() {
  var headeHeight = 65;
  window.addEventListener('scroll', ()=> {
    var scrollY = window.scrollY;
    if (scrollY > headeHeight) {
      document.body.classList.add('scrolled')
    } else {
       document.body.classList.remove('scrolled');
    }
  })
}

export default addScrolledClassToBody